import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  FilterDTO,
  FilterOperator,
  ParkerCompanyClient,
  SortDirection,
  IParkerCompanyDTO,
} from 'src/app/base/models/models.swagger.generated';


// Do not use this service in root to avoid caching problems
@Injectable()
export class CompanyService {
  public companies: IParkerCompanyDTO[] = [];

  public clientId: number;

  constructor(private parkerCompanyClient: ParkerCompanyClient) {
  }

  public getCompanies(clientId: number): Observable<IParkerCompanyDTO[]> {
    if (this.clientId === clientId) {
      return of(this.companies);
    }

    const filters = [];
    filters.push(new FilterDTO({ isComplex: false, field: 'Active', operator: FilterOperator.Equal, value: 'true' }));
    return this.parkerCompanyClient.searchParkerCompanies(clientId, filters, 0, 0, 'Name', SortDirection.Ascending)
      .pipe(
        map(pagedResult => {
          this.companies = pagedResult.items;
          this.clientId = clientId;
          return this.companies;
        }));

  }
}
